import { isDebugAllowed } from './helpers';

export const pushEvent = (name, data) => {
  if (isDebugAllowed()) {
    // eslint-disable-next-line no-console
    console.log({name, data});
  }
  document.dispatchEvent(new CustomEvent('travelyo:hf', {
    detail: {
      name,
      data
    }
  }));
};

const eventLog = name => {
  // eslint-disable-next-line no-console
  console.log(`Event ${name} called.`);
};

export const createAnalyticsListener = () => {
  document.addEventListener('travelyo:hf', event => { eventLog(event.detail.name); });
};

export const pushFbEvent = (FbProductId) => {
  console.log('FbTrackEvent', 'Search', { FbProductId });
  document.dispatchEvent(new CustomEvent('FbTrackEvent', {
    detail: {
      name: 'FbTrackEvent',
      type: 'Search',
      productType : 'hotel',
      value: { FbProductId }
    }
  }));

  /*
  console.log('FbTrackEvent', 'ViewContent', { FbProductId });
  document.dispatchEvent(new CustomEvent('FbTrackEvent', {
    detail: {
      name: 'FbTrackEvent',
      type: 'ViewContent',
      productType : 'destination',
      value: { FbProductId }
    }
  }));
  */
};
